export default "__VITE_ASSET__isZjGmgj__"